// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable react/no-unsafe, babel/camelcase, react/destructuring-assignment */
import * as React from "react"
// @ts-expect-error: Flow to TS migration.
import { connect, Connector } from "react-redux"
// @ts-expect-error: Flow to TS migration.
import type { Route } from "react-router-config"
import * as R from "ramda"

import * as globalActions from "../../services/params/actions"

type OwnProps = {
  routes?: Route[]
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  params?: {
    [key: string]: string | null | undefined
  }
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  query: {
    [key: string]: string
  }
  children?: React.ReactNode
}

type Props = OwnProps & {
  updateRoute: typeof globalActions.updateRoute
}

class UpdateRoute extends React.PureComponent<Props> {
  componentDidMount() {
    const { updateRoute, params, routes, query } = this.props

    // Update the route only if routes are available (which may not always be the case as some
    // pages are not using routing at all).
    if (routes) {
      updateRoute(params, routes, query)
    }
  }

  UNSAFE_componentWillUpdate(nextProps: Props) {
    const { updateRoute, params, query, routes } = this.props
    const nextPropRoutes = nextProps.routes
    // Update the route only if routes are available (which may not always be the case as some
    // pages are not using routing at all).
    if (!routes || !nextPropRoutes) {
      return
    }

    const paramsEq = R.equals(params, nextProps.params)
    const queryEq = R.equals(query, nextProps.query)
    const routesEq = R.equals(
      routes.map((route) => route.name).filter(Boolean),
      nextPropRoutes.map((route) => route.name).filter(Boolean),
    )
    if (!paramsEq || !routesEq || !queryEq) {
      updateRoute(nextProps.params, nextProps.routes, nextProps.query)
    }
  }

  render() {
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return this.props.children || null
  }
}

const connector: Connector<OwnProps, Props> = connect(null, {
  updateRoute: globalActions.updateRoute,
})

export default connector(UpdateRoute)
